import { Flex, Spinner } from '@chakra-ui/react';

const FullScreenLoader = () => (
  <Flex align="center" justify="center" h="100vh" w="100vw" bg="white">
    <Spinner size="xl" color="purple.500" thickness="4px" speed="0.65s" />
  </Flex>
);

export default FullScreenLoader; 